exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sort-icon-container[data-v-6ec4d2f2]{line-height:.5;display:inline-flex;align-items:center;justify-content:center}.size-10[data-v-6ec4d2f2]{width:10px!important;height:10px!important}", ""]);

// exports
